export const CUSTOM_ERROR_NAME = 'CUSTOM_ERROR';
//# sourceMappingURL=constants.js.map